(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ms-pdp-rating"] && !Shopify.designMode) return;
  try {
    /* El enlace de la calificación baja a las reseñas solo si existen en la página.
     El destino se resuelve al hacer clic (los widgets de app se inyectan tarde);
     si tres segundos después de cargar no hay a dónde ir, deja de ser enlace. */
  (function () {
    var CANDIDATOS = [
      '#ms-reviews',
      '#lmReview',
      '[id*="revie_reviews"]',
      '.jdgm-rev-widg',
      '#judgeme_product_reviews',
      '#looxReviews',
      '[class*="yotpo-reviews"]',
      '.yotpo-main-widget',
      '#stamped-main-widget',
      '.okeReviews-reviewsWidget',
      '#shopify-product-reviews'
    ];

    function destino(enlace) {
      var lista = [];
      var propio = enlace.getAttribute('href') || '';
      if (propio.charAt(0) === '#' && propio.length > 1) lista.push(propio);
      lista = lista.concat(CANDIDATOS);
      var primero = null;
      for (var i = 0; i < lista.length; i++) {
        var nodos;
        try { nodos = document.querySelectorAll(lista[i]); } catch (e) { continue; }
        for (var j = 0; j < nodos.length; j++) {
          if (enlace.contains(nodos[j])) continue;
          if (!primero) primero = nodos[j];
          // Un widget de app que aún no pinta mide 0: gana el que ya tiene caja.
          if (nodos[j].getBoundingClientRect().height > 0) return nodos[j];
        }
      }
      return primero;
    }

    function apagar(enlace) {
      enlace.removeAttribute('href');
      enlace.removeAttribute('data-ms-rating-link');
      var pista = enlace.querySelector('[data-ms-rating-link-hint]');
      if (pista) pista.remove();
    }

    document.addEventListener('click', function (evento) {
      var enlace = evento.target.closest ? evento.target.closest('[data-ms-rating-link]') : null;
      if (!enlace) return;
      evento.preventDefault();
      var objetivo = destino(enlace);
      if (!objetivo) { apagar(enlace); return; }
      var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      objetivo.scrollIntoView({ behavior: suave ? 'smooth' : 'auto', block: 'start' });
    });

    function revisar() {
      var enlaces = document.querySelectorAll('[data-ms-rating-link]');
      for (var i = 0; i < enlaces.length; i++) {
        if (!destino(enlaces[i])) apagar(enlaces[i]);
      }
    }

    if (!(window.Shopify && window.Shopify.designMode)) {
      window.addEventListener('load', function () { window.setTimeout(revisar, 3000); });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["scroll-reveal-timeline"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('scroll-reveal-timeline')) {
    class ScrollRevealTimeline extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-timeline-item]'));
        this.track = this.querySelector('[data-timeline-track]');
        this.icons = Array.from(this.querySelectorAll('.scroll-timeline__icon'));
        this.frame = null;
        this.update = this.update.bind(this);
        this.queueUpdate = this.queueUpdate.bind(this);
        window.addEventListener('scroll', this.queueUpdate, { passive: true });
        window.addEventListener('resize', this.queueUpdate, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.queueUpdate);
        window.removeEventListener('resize', this.queueUpdate);
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      queueUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(this.update);
      }

      update() {
        this.frame = null;
        const viewportHeight = window.innerHeight;
        const clearLine = viewportHeight * 0.68;
        const fadeLine = viewportHeight * 0.94;
        const range = fadeLine - clearLine;

        this.items.forEach((item) => {
          const center = item.getBoundingClientRect().top + Math.min(item.offsetHeight * 0.25, 48);
          const progress = Math.max(0, Math.min(1, (fadeLine - center) / range));
          item.style.setProperty('--reveal-progress', progress.toFixed(3));
        });

        if (this.track && this.icons.length > 1) {
          const listRect = this.track.parentElement.getBoundingClientRect();
          const firstRect = this.icons[0].getBoundingClientRect();
          const lastRect = this.icons[this.icons.length - 1].getBoundingClientRect();
          const trackTop = firstRect.top + (firstRect.height / 2);
          const trackBottom = lastRect.top + (lastRect.height / 2);
          const trackHeight = Math.max(0, trackBottom - trackTop);
          const trackLeft = firstRect.left + (firstRect.width / 2);
          const progress = trackHeight > 0
            ? Math.max(0, Math.min(1, (clearLine - trackTop) / trackHeight))
            : 0;

          this.track.style.top = `${trackTop - listRect.top}px`;
          this.track.style.left = `${trackLeft - listRect.left - (this.track.offsetWidth / 2)}px`;
          this.track.style.height = `${trackHeight}px`;
          this.track.style.setProperty('--track-fill', progress.toFixed(3));
        }
      }
    }

    customElements.define('scroll-reveal-timeline', ScrollRevealTimeline);
  }
  } catch(e) { console.error(e); }
})();

})();
